module.exports = __webpack_public_path__ + "static/locales/ms.10dB_jJ.json";